import type { RewardDraft } from '../../types/reward';

export function validateRewardInput(input: Pick<RewardDraft, 'name' | 'pointsCost' | 'stock'>): string | null {
  if (!input.name.trim()) return 'Please enter a reward name.';
  if (!Number.isSafeInteger(input.pointsCost) || input.pointsCost <= 0) {
    return 'Points cost must be a positive whole number.';
  }
  if (!Number.isSafeInteger(input.stock) || input.stock < 0) {
    return 'Stock must be zero or a positive whole number.';
  }
  return null;
}
